import { render, staticRenderFns } from "./PackagesExport.vue?vue&type=template&id=1f38c67c&scoped=true&"
import script from "./PackagesExport.vue?vue&type=script&lang=js&"
export * from "./PackagesExport.vue?vue&type=script&lang=js&"
import style0 from "./PackagesExport.vue?vue&type=style&index=0&id=1f38c67c&lang=scss&scoped=true&"
import style1 from "./PackagesExport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38c67c",
  null
  
)

export default component.exports